import moment from "moment";
import axios from "axios";
import { takeLatest, call, put, select } from "redux-saga/effects";
import { queryParams } from "../../../../utils/queryParams";
import { createAction } from "redux-actions";
import { getIds } from "../../../../utils/getIds";
import { API_DATE_FORMAT } from "../../../../app_constants";

export const FETCH_CURRENT_USER_SUCCESS = "sagas/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_FILTERS_SUCCESS = "sagas/FETCH_FILTERS_SUCCESS";
export const FETCH_CHART_SUCCESS = "saga/FETCH_CHART_SUCCESS";
export const FETCH_CURRENT_USER = "sagas/FETCH_CURRENT_USER";

export const SET_UPDATES_LOADING = "saga/SET_UPDATES_LOADING";
export const SET_FILTERS_DIRTY = "saga/SET_FILTERS_DIRTY";
export const SET_LOADING = "saga/SET_LOADING";
export const SET_DATES = "saga/SET_DATES";
export const SET_SHOW_VALIDATE_MESSAGE = "saga/SHOW_VALIDATE_MESSAGE";

export const UPDATE_GROUP_CATEGORY_SELECTED = "sagas/UPDATE_GROUP_CATEGORY_SELECTED";
export const UPDATE_SUBSCRIPTION_FILTER = "sagas/UPDATE_SUBSCRIPTION_FILTER";
export const UPDATE_TABLE_VIEW_SELECTED = "saga/UPDATE_TABLE_VIEW_SELECTED";
export const UPDATE_SELECTED_FILTERS = "saga/UPDATE_SELECTED_FILTERS";
export const UPDATE_GROUP_CATEGORY = "sagas/UPDATE_GROUP_CATEGORY";
export const UPDATE_SOURCE_FILTER = "saga/UPDATE_SOURCE_FILTER";
export const UPDATE_CUSTOM_RANGE = "saga/UPDATE_CUSTOM_RANGE";
export const UPDATE_CHART = "saga/UPDATE_CHART";
export const UPDATE_DATES = "saga/UPDATE_DATES";
const UPDATE_TABLE_VIEW = "saga/UPDATE_TABLE_VIEW";
const RESET_FILTERS = "saga/RESET_FILTER";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateSelectedFilters: createAction(UPDATE_SELECTED_FILTERS),
  updateGroupCategory: createAction(UPDATE_GROUP_CATEGORY),
  updateSourceFilter: createAction(UPDATE_SOURCE_FILTER),
  updateCustomRange: createAction(UPDATE_CUSTOM_RANGE),
  updateTableView: createAction(UPDATE_TABLE_VIEW),
  resetFilters: createAction(RESET_FILTERS),
  updateSubscriptionFilter: createAction(UPDATE_SUBSCRIPTION_FILTER),
  updateChart: createAction(UPDATE_CHART),
  updateDates: createAction(UPDATE_DATES),
  setShowValidationMessage: createAction(SET_SHOW_VALIDATE_MESSAGE)
};

export default function* watchIntroBreakdown() {
  yield takeLatest(FETCH_CURRENT_USER, fetchCurrentUserData);
  yield takeLatest(UPDATE_GROUP_CATEGORY, updateGroupCategory);
  yield takeLatest(UPDATE_TABLE_VIEW, updateTableView);
  yield takeLatest(UPDATE_CHART, updateData);
  yield takeLatest(RESET_FILTERS, resetFilters);
}

function* updateGroupCategory({ payload }) {
  yield put({ type: UPDATE_GROUP_CATEGORY_SELECTED, payload });
}

function* getCommonApiParams() {
  const { organization_id, short_url } = yield select((state) => state.commonReducer.commonProps);

  return yield select((state) => {
    const {
      selectedRequestDates: { endDate, startDate },
      selectedFilters: { groupBySubscription, periodType, selectedSubscriptions, table_view }
    } = state.onDemandRevenue;

    return [
      organization_id,
      short_url,
      startDate,
      endDate,
      groupBySubscription,
      periodType,
      selectedSubscriptions,
      table_view
    ];
  });
}

function* fetchCurrentUserData(data) {
  yield put({
    type: FETCH_CURRENT_USER_SUCCESS,
    payload: data.payload
  });
  yield setDates();

  try {
    yield put({ type: SET_LOADING, payload: true });
    yield fetchFilters();
    yield fetchChart();

    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* fetchFilters() {
  const [organization_id, short_url, start_date, end_date] = yield getCommonApiParams();

  const params = {
    organization_id,
    short_url,
    start_date,
    end_date
  };

  const baseUrl =
    queryParams.apiVersion + "pages/subscription_sales/on_demand_revenue_chart/filters";

  try {
    const response = yield call(axios.get, baseUrl, { params });

    yield put({ type: FETCH_FILTERS_SUCCESS, payload: response.data });
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (err) {
    console.error(err);
  }
}

function* updateData() {
  yield put({ type: SET_SHOW_VALIDATE_MESSAGE, payload: false });
  yield put({ type: SET_UPDATES_LOADING, payload: true });
  yield put({ type: SET_FILTERS_DIRTY, payload: false });
  try {
    yield fetchChart();
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* fetchChart() {
  const [
    organization_id,
    short_url,
    startDate,
    endDate,
    groupBySubscription,
    periodType,
    selectedSubscriptions,
    table_view
  ] = yield getCommonApiParams();
  try {
    const response = yield call(
      axios.post,
      queryParams.apiVersion + "pages/subscription_sales/on_demand_revenue_chart",
      {
        organization_id: organization_id,
        short_url,
        period_type: periodType.toLowerCase(),
        start_date: startDate,
        end_date: endDate,
        group_by_subscriptions: groupBySubscription,
        pricing_options: getIds(selectedSubscriptions),
        table_view: table_view
      }
    );

    yield put({ type: FETCH_CHART_SUCCESS, payload: response.data });
  } catch (err) {
    console.error(err);
  }
}

function* resetFilters() {
  yield setDates();
  try {
    yield fetchFilters();
    yield put({ type: SET_UPDATES_LOADING, payload: true });
    yield fetchChart();
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* updateTableView({ payload }) {
  const { selectedSubscriptions } = yield select((state) => state.onDemandRevenue.selectedFilters);

  if (!selectedSubscriptions.length) {
    yield put({ type: SET_SHOW_VALIDATE_MESSAGE, payload: true });
    return;
  }

  yield put({ type: SET_UPDATES_LOADING, payload: true });
  yield put({ type: UPDATE_TABLE_VIEW_SELECTED, payload });

  try {
    yield fetchChart();
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* setDates() {
  const endDate = yield select((state) => state.onDemandRevenue.currentUser.calendarEndDate);
  const startDate = moment(endDate).startOf("month").subtract(11, "months").format(API_DATE_FORMAT);
  yield put({
    type: SET_DATES,
    payload: {
      startDate,
      endDate: endDate
    }
  });
}
